import { useEffect, useState } from "react";
import { usePictureSets } from "../../hooks/usePictureSets";
export const usePictureSet = (pictureSetUuid) => {
    const { isLoaded, pictureSets } = usePictureSets();
    const [pictureSet, setPictureSet] = useState(null);
    const [notFound, setNotFound] = useState(false);
    useEffect(() => {
        if (!isLoaded || pictureSets === null) {
            return;
        }
        const ps = pictureSets.find((p) => p.subject.uuid == pictureSetUuid);
        if (ps) {
            setPictureSet(ps);
            setNotFound(false);
        }
        else {
            setPictureSet(null);
            setNotFound(true);
        }
    }, [pictureSets, pictureSetUuid]);
    return {
        pictureSet,
        notFound,
    };
};
